import { Navigate, Outlet } from "react-router-dom";
import { isLoggedIn } from "../utils/auth";

const PublicRoute = () => {
  if (isLoggedIn()) {
    return <Navigate to="/feed/prime" replace />;
  }

  return <Outlet />;
};

export default PublicRoute;